__turbopack_context__.v({
  "anzeige": "ApoBankCta-module__NgHHGG__anzeige",
  "block": "ApoBankCta-module__NgHHGG__block",
  "content": "ApoBankCta-module__NgHHGG__content",
  "coopCorner": "ApoBankCta-module__NgHHGG__coopCorner",
  "ctaBtn": "ApoBankCta-module__NgHHGG__ctaBtn",
  "ctaImg": "ApoBankCta-module__NgHHGG__ctaImg",
  "hl": "ApoBankCta-module__NgHHGG__hl",
  "lgBank": "ApoBankCta-module__NgHHGG__lgBank",
  "lgCampus": "ApoBankCta-module__NgHHGG__lgCampus",
  "logos": "ApoBankCta-module__NgHHGG__logos",
  "mark": "ApoBankCta-module__NgHHGG__mark",
  "sub": "ApoBankCta-module__NgHHGG__sub",
  "visual": "ApoBankCta-module__NgHHGG__visual",
});
